export default __webpack_public_path__ + "static/media/sc-bi-active-ico.7c7d8d3a.svg";